import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pivot",
  "use": "icon-pivot-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-pivot\"><path d=\"M9 4v3h16c2.2 0 4 1.8 4 4v14c0 2.2-1.8 4-4 4H11c-2.2 0-4-1.8-4-4V9H4V7h3V4zm16 5-7-.001V9H9v8h-.001L9 25c0 1.2.8 2 2 2h14c1.2 0 2-.8 2-2V11c0-1.2-.8-2-2-2m-4 2 4 4h-3v4c0 1.6-1.4 3-3 3h-2v3l-4-4 4-4v3h2c.6 0 1-.4 1-1v-4h-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol